import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { RecognitionModal } from "./RecognitionModal";
import { useDeleteUserProfileSectionItem } from "Constant/apiHooks";
import { VIEW_PROFILE_SECTIONS } from "Constant/constants";
import { formatMonthYear } from "Utils";

export const Recognitions = ({ recognitionList, fetchData, isCurrentUserProfile }) => {
  const { t } = useTranslation();

  const { deleteUserProfileSectionItem } = useDeleteUserProfileSectionItem();

  const [recognitionModal, setRecognitionModal] = useState(false);
  const [selectedRecognition, setSelectedRecognition] = useState(null);

  const toggleRecognitionModal = (recogntn) => {
    setRecognitionModal((prev) => !prev);
    if (recogntn) {
      setSelectedRecognition(recogntn);
    } else {
      setSelectedRecognition(null);
    }
  };

  const handleDeleteRecognition = async (gid) => {
    try {
      const payload = {
        key: VIEW_PROFILE_SECTIONS.recognition,
        [VIEW_PROFILE_SECTIONS.recognition]: {
          gid,
        },
      };
      await deleteUserProfileSectionItem(payload);
      fetchData();
    } catch {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
        <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 row-gap-2 mb-3">
          <h4 className="mb-0 text-md font-semibold text-grey-800">
            Recognition & Outreach
          </h4>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <button
                type="button"
                className="btn btn-gray-light font-medium rounded-lg d-inline-flex align-items-center gap-1"
                onClick={() => toggleRecognitionModal()}
              >
                <i className="bx bx-plus"></i>{" "}
                {t("auth.viewProfile.addRecognition")}
              </button>
            </div>
          )}
        </div>

        <ul className="list-border-style list-unstyled mb-0 d-flex flex-column justify-content-center row-gap-0">
          {recognitionList && recognitionList.length > 0 ? (
            recognitionList.map((recogntn, idx) => (
              <li key={idx.toString()}>
                <div className="d-flex gap-3 py-4">
                  <div className="w-16 h-16 flex-auto rounded-circle overflow-hidden d-flex justify-content-center align-items-center bg-grey-100">
                    <img
                      src="/assets/images/placeholder.jpg"
                      alt=""
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                  <div className="d-flex flex-column gap-1 w-100">
                    <div className="d-flex gap-3">
                      <div className="d-flex align-items-center gap-3 w-100">
                        <h5 className="mb-0 text-base font-semibold text-grey-800">
                          {recogntn.title}
                        </h5>
                        {isCurrentUserProfile && (
                          <div className="ms-auto d-flex align-items-center gap-3">
                            <Button
                              variant="link"
                              className="p-0 text-base text-grey-600 text-decoration-none"
                              onClick={() => toggleRecognitionModal(recogntn)}
                            >
                              <i className="bx bx-pencil"></i>
                            </Button>
                            <Button
                              variant="link"
                              className="p-0 text-base text-grey-600 text-decoration-none"
                              onClick={() => handleDeleteRecognition(recogntn.gid)}
                            >
                              <i className="bx bx-trash"></i>
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                    <span>
                      {t("common.label.awardedOrganization")}:{" "}
                      {recogntn.awardedOrganization}
                    </span>

                    <ul className="inline-list-pipe-style list-unstyled d-inline-flex align-items-center">
                      <li>
                        {recogntn.type === "Other"
                          ? recogntn.otherTypeOfRecognition
                          : recogntn.type}
                      </li>
                      <li>,</li>
                      <li>{formatMonthYear(recogntn.dateOfActivity)}</li>
                    </ul>

                    <div>
                      {recogntn.awardDescription}
                    </div>
                    <a
                      href={recogntn.linkToFurtherDetails}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {recogntn.linkToFurtherDetails}
                    </a>
                  </div>
                </div>

                {recogntn.uploadCertificateOrDocument && (
                  <ul className="resume-uploaded-list list-unstyled mt-3 mb-0 d-flex flex-column justify-content-center row-gap-2">
                    <li className="p-3 rounded-lg border border-primary-200 bg-primary-50 d-flex justify-content-between align-items-center gap-3 text-decoration-none">
                      <div>
                        <h5 className="mb-0 text-sm font-semibold text-primary-800">
                          {recogntn.uploadCertificateOrDocument.name}
                        </h5>
                        <span className="text-xs font-medium text-grey-500">
                          Uploaded on March 2025
                        </span>
                      </div>
                      <div className="d-flex align-items-center gap-1">
                        <a
                          href={recogntn.uploadCertificateOrDocument.url}
                          target="_blank"
                          className="border-0 bg-transparent text-base text-primary-600 w-8 h-8 d-flex justify-content-center align-items-center text-decoration-none"
                        >
                          <i className="bx bx-show-alt"></i>
                        </a>
                      </div>
                    </li>
                  </ul>
                )}
              </li>
            ))
          ) : (
            <li>
              <div className="">
                <span className="text-grey-400">{t("auth.viewProfile.noRecognitionAndOutreach")}</span>
              </div>
            </li>
          )}
        </ul>
      </div>

      {recognitionModal && (
        <RecognitionModal
          show={recognitionModal}
          recognitionData={selectedRecognition}
          toggle={toggleRecognitionModal}
          fetchData={fetchData}
        />
      )}
    </>
  );
};
